import React from "react";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase Component/firebase-config";
import { DeleteData } from "../firebase Component/DeleteData";



function sort_by_number() {
  return function (elem1, elem2) {
    if (elem1.number < elem2.number) {
      return -1;
    } else if (elem1.number > elem2.number) {
      return 1;
    } else {
      return 0;
    }
  };
}

function DeleteChat() {
  const CollectionName = "LiveChat";
  const [Data, setData] = useState([]);
  const dataRef = collection(db, String(CollectionName));
    // eslint-disable-next-line
  const [index , setIndex] = useState(null);
  const DataFetching = async () => {
    const data = await getDocs(dataRef);
    
     const ArrData = data.docs.map((recData) => ({ ...recData.data(), id: recData.id }))
     setIndex(ArrData.length+1)
    const Arr = ArrData.filter((num)=> num.read === false)
     Arr.sort(sort_by_number())
     setData(Arr)
    
  };

  // eslint-disable-next-line
  useEffect(() => {
    DataFetching();

    // eslint-disable-next-line
  }, []);


  const [formData, setFormData] = useState({
    name: "",
    msg: "",
  });

  const HandleChange = (name, data) => {
    setFormData({ ...formData, [name]: data });
  };



const DeleteDocuments = ()=>{
      // eslint-disable-next-line
    Data.map((data)=>{
        DeleteData(CollectionName,data.id)
    })
}
  return (
    <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">

      <section class="text-gray-600 body-font relative">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-12 invisible">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Write your Msg Here
            </h1>
          </div>
          <div class="lg:w-1/2 md:w-2/3 mx-auto">
            <div class="flex flex-wrap -m-2">
              <div class="p-2 w-1/2">
                <div class="relative">
                <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Choose the name</label>
<select onChange={(e)=>{
 HandleChange("name",e.target.value)
}} id="countries" class="bg-gray-50 border border-gray-300 text-cusOrange text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
  <option selected>Name</option>
  <option value="Maazy">Maazy</option>
  <option value="Zaino">Zaino</option>

</select>
                </div>
              </div>
              <div class="p-2 w-1/2 invisible">
                <div class="relative">
                  <label for="email" class="leading-7 text-sm text-gray-600">
                    Title
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 text-base outline-none text-cusLightBlack py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
              </div>
              <div class="p-2 w-full invisible">
                <div class="relative">
                  <label for="message" class="leading-7 text-sm text-gray-600">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    class="w-full bg-gray-100 bg-opacity-50 text-cusLightBlack rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                    onChange={(e) => {
                      HandleChange("msg", e.target.value);
                    }}
                  ></textarea>
                </div>
              </div>
              <div class="p-2 w-full">
                <button
                  class="flex mx-auto bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg"
                  onClick={() => {
                    DeleteDocuments();
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DeleteChat;
